import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Oneseventempotravelleronrent() {



  const cardData = {
"keyword": "17 Seater Tempo Traveller On Rent in Pune",

"headingDescription":
  "Aaradhya Travels offers reliable 17 Seater Tempo Traveller On Rent in Pune for family trips, corporate travel, weddings, airport transfers, school tours, and outstation group journeys. Our 17-seater tempo travellers are well-maintained and equipped with air-conditioning, comfortable pushback seats, charging points, luggage space, and experienced drivers familiar with Pune city and highway routes. We ensure safe, comfortable, and punctual group travel with doorstep pickup from all major areas of Pune for both local and long-distance journeys.",

"topPlaces": [
 {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a famous hill destination near Pune offering cool weather, strawberry farms, viewpoints, and refreshing monsoon scenery."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a historic city near Pune known for vineyards, temples, and the sacred Trimbakeshwar Jyotirlinga shrine."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort near Pune is a historic hill fort offering trekking routes and panoramic views of the Sahyadri mountains."
  },
    {
    "title": "Lavasa City",
    "description": "Lavasa is a planned hill city near Pune featuring lakeside views, colorful architecture, and a peaceful environment for short holidays."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is a major pilgrimage town near Pune dedicated to Sai Baba, attracting devotees throughout the year for spiritual visits."
  },
   {
    "title": "Lonavala",
    "description": "Lonavala is a popular hill station near Pune known for scenic valleys, waterfalls, and weekend getaways, perfect for group and family trips."
  },
  {
    "title": "Karla Bhaja Caves",
    "description": "Karla and Bhaja Caves near Pune are ancient Buddhist rock-cut caves known for historical significance and architectural beauty."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake near Lonavala is a popular camping destination offering lakeside stays, bonfires, and adventure activities."
  },
  {
    "title": "Mumbai",
    "description": "Mumbai is a major metro city near Pune, popular for business trips, tourism, beaches, and weekend travel."
  },
  {
    "title": "Khandala",
    "description": "Khandala is a scenic hill station close to Lonavala, famous for valleys, viewpoints, and monsoon landscapes."
  }
],



services: [
  {
    name: "13 Seater AC Tempo Traveller Pune",
    description: "13 seater AC tempo traveller Pune service provides premium air-conditioned transportation for family trips, airport transfers, corporate travel, and sightseeing journeys. Spacious seating and comfortable interiors ensure pleasant travel experiences suitable for local and outstation group transportation. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient 13 seater AC tempo traveller reservations."
  },
  {
    name: "13 Seater Tempo Traveller Hire Pune",
    description: "13 seater tempo traveller hire Pune service offers reliable transportation for weddings, office outings, educational tours, pilgrimage trips, and family vacations. Comfortable seating and ample luggage space ensure smooth journeys suitable for medium-sized passenger groups. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient 13 seater tempo traveller hire reservations."
  },
  {
    name: "13 Seater Luxury Traveller Pune",
    description: "13 seater luxury traveller Pune service provides premium transportation with elegant interiors and spacious seating for corporate travel, weddings, sightseeing tours, and family vacations. Smooth highway travel ensures comfortable journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient luxury traveller reservations."
  },
  {
    name: "13 Seater Pune to Shirdi Traveller",
    description: "13 seater Pune to Shirdi traveller service provides comfortable transportation for pilgrimage tours, Sai Baba temple visits, family trips, and group travel. Spacious seating and smooth highway travel ensure pleasant journeys suitable for long-distance temple tours. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Shirdi traveller reservations."
  },
  {
    name: "13 Seater Pune to Mahabaleshwar Traveller",
    description: "13 seater Pune to Mahabaleshwar traveller service offers reliable transportation for hill station vacations, sightseeing tours, weekend trips, and family outings. Comfortable seating and smooth ghat road travel ensure enjoyable journeys suitable for group travel. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Mahabaleshwar traveller reservations."
  },
  {
    name: "13 Seater Airport Pickup Pune",
    description: "13 seater airport pickup Pune service provides dependable transportation for airport transfers, tourist groups, business travelers, and family travel requirements. Spacious seating and luggage space ensure comfortable journeys suitable for local and outstation airport transportation. Professional chauffeurs ensure timely airport pickups and safe driving services throughout the route. Pickup services are available from Pune Airport, homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient airport pickup traveller reservations."
  },
  {
    name: "13 Seater Wedding Traveller Pune",
    description: "13 seater wedding traveller Pune service offers stylish transportation for marriage ceremonies, bridal parties, wedding guests, and family travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding celebrations and event transportation. Professional drivers ensure punctual pickup and reliable transportation services throughout the wedding itinerary. Pickup services are available from homes, banquet halls, hotels, and residential areas across Pune. Flexible booking options allow convenient wedding traveller reservations."
  },
  {
    name: "13 Seater Corporate Traveller Pune",
    description: "13 seater corporate traveller Pune service provides professional transportation for office staff, conferences, business meetings, corporate outings, and employee travel requirements. Comfortable seating ensures smooth journeys suitable for executive passengers and office teams. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from offices, commercial hubs, hotels, and business locations across Pune. Flexible booking options allow convenient corporate traveller reservations."
  },
  {
    name: "13 Seater Outstation Traveller Pune",
    description: "13 seater outstation traveller Pune service provides dependable long-distance transportation for Goa tours, pilgrimage journeys, sightseeing trips, family vacations, and tourist travel. Spacious seating and luggage space ensure comfortable highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient outstation traveller reservations."
  },
  {
    name: "13 Seater Family Trip Pune",
    description: "13 seater family trip Pune service offers dependable transportation for holiday vacations, sightseeing tours, pilgrimage journeys, and family outings. Spacious seating and comfortable interiors ensure pleasant journeys suitable for local and outstation family group travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient family trip traveller reservations."
  },
  {
    name: "13 Seater Group Travel Pune",
    description: "13 seater group travel Pune service provides spacious transportation for educational tours, sightseeing journeys, office outings, family vacations, and tourist travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium-sized passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient group travel reservations."
  },
  {
    name: "13 Seater Hinjewadi Traveller",
    description: "13 seater Hinjewadi traveller service provides dependable transportation for IT employees, office commute, business meetings, and employee shuttle travel requirements. Comfortable seating ensures smooth journeys suitable for office staff and corporate passenger groups. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and business hubs across Hinjewadi Pune. Flexible booking options allow convenient Hinjewadi traveller reservations."
  },
  {
    name: "13 Seater Kharadi Traveller",
    description: "13 seater Kharadi traveller service offers reliable transportation for corporate travel, office outings, airport transfers, and group travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for IT employees and family groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial hubs across Kharadi Pune. Flexible booking options allow convenient Kharadi traveller reservations."
  },
  {
    name: "13 Seater Baner Traveller",
    description: "13 seater Baner traveller service provides comfortable transportation for family trips, office travel, airport pickups, and sightseeing journeys. Spacious seating and luggage space ensure smooth journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Baner Pune. Flexible booking options allow convenient Baner traveller reservations."
  },
  {
    name: "13 Seater Wakad Traveller",
    description: "13 seater Wakad traveller service provides reliable transportation for office commute, family outings, airport transfers, and outstation group travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for business and leisure travel requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Wakad Pune. Flexible booking options allow convenient Wakad traveller reservations."
  },
  {
    name: "13 Seater Pimpri Chinchwad Traveller",
    description: "13 seater Pimpri Chinchwad traveller service offers dependable transportation for corporate travel, family vacations, wedding functions, and airport transfers. Spacious seating and luggage capacity ensure smooth journeys suitable for local and outstation passenger movement. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "13 Seater Pune Darshan Traveller",
    description: "13 seater Pune Darshan traveller service offers dependable transportation for sightseeing tours, tourist visits, heritage travel, and family outings across Pune city attractions. Spacious seating ensures comfortable journeys suitable for local tourism and group travel requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the tour route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Pune Darshan traveller reservations."
  },
  {
    name: "13 Seater Luxury AC Van Pune",
    description: "13 seater luxury AC van Pune service provides premium transportation with modern interiors and comfortable seating for weddings, corporate travel, airport transfers, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient luxury AC van reservations."
  },
  {
    name: "13 Seater Tourist Traveller Pune",
    description: "13 seater tourist traveller Pune service provides dependable transportation for sightseeing tours, holiday vacations, family outings, and tourist travel requirements. Spacious seating and luggage space ensure comfortable journeys suitable for local and outstation tourism activities. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient tourist traveller reservations."
  },
  {
    name: "13 Seater Private Hire Pune",
    description: "13 seater private hire Pune service offers comfortable transportation for family functions, business meetings, airport travel, sightseeing tours, and group travel requirements. Spacious seating ensures smooth journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient private hire traveller reservations."
  },
  {
    name: "13 Seater Weekend Trip Pune",
    description: "13 seater weekend trip Pune service offers comfortable transportation for holiday getaways, hill station tours, sightseeing journeys, and family vacations. Spacious seating and smooth highway travel ensure pleasant travel experiences suitable for local and outstation weekend trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient weekend trip traveller reservations."
  },
  {
    name: "13 Seater Lonavala Traveller",
    description: "13 seater Lonavala traveller service provides reliable transportation for hill station vacations, sightseeing tours, tourist travel, and weekend trips from Pune. Comfortable seating and smooth expressway travel ensure pleasant journeys suitable for family and group travel. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Lonavala traveller reservations."
  },
  {
    name: "13 Seater Shirdi Darshan Pune",
    description: "13 seater Shirdi Darshan Pune service offers dependable transportation for Sai Baba temple visits, pilgrimage journeys, family tours, and religious group travel. Spacious seating and smooth highway travel ensure comfortable journeys suitable for long-distance temple tours. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient Shirdi Darshan traveller reservations."
  },
  {
    name: "13 Seater IT Park Transport Pune",
    description: "13 seater IT park transport Pune service provides professional transportation for office staff, employee shuttle travel, corporate meetings, and business commute requirements. Comfortable seating ensures smooth journeys suitable for daily office travel and executive passenger movement. Professional chauffeurs ensure reliable transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, homes, and business hubs across Pune. Flexible booking options allow convenient IT park transport reservations."
  },
  {
    name: "13 Seater Event Travel Pune",
    description: "13 seater event travel Pune service provides dependable transportation for corporate functions, concerts, exhibitions, weddings, conferences, and social gatherings. Spacious seating ensures smooth journeys suitable for local and outstation event travel requirements. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and event venues across Pune. Flexible booking options allow convenient event travel reservations."
  }
],

tableData: [
  ["13 Seater AC Tempo Traveller Pune", "13 Seater Tempo Traveller Hire Pune"],
  ["13 Seater Luxury Traveller Pune", "13 Seater Pune to Shirdi Traveller"],
  ["13 Seater Pune to Mahabaleshwar Traveller", "13 Seater Airport Pickup Pune"],
  ["13 Seater Wedding Traveller Pune", "13 Seater Corporate Traveller Pune"],
  ["13 Seater Outstation Traveller Pune", "13 Seater Family Trip Pune"],
  ["13 Seater Group Travel Pune", "13 Seater Hinjewadi Traveller"],
  ["13 Seater Kharadi Traveller", "13 Seater Baner Traveller"],
  ["13 Seater Wakad Traveller", "13 Seater Pimpri Chinchwad Traveller"],
  ["13 Seater Pune Darshan Traveller", "13 Seater Luxury AC Van Pune"],
  ["13 Seater Tourist Traveller Pune", "13 Seater Private Hire Pune"],
  ["13 Seater Weekend Trip Pune", "13 Seater Lonavala Traveller"],
  ["13 Seater Shirdi Darshan Pune", "13 Seater IT Park Transport Pune"],
  ["13 Seater Event Travel Pune", "13 Seater Group Travel Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 17 Seater Tempo Traveller On Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 17 seater Tempo Traveller rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for family trips, corporate tours, and group travel."
      },
      {
        WhyChooseheading: "Affordable 17 Seater Tempo Traveller Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 17 seater Tempo Traveller on rent in Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our 17 seater Tempo Traveller service in Pune operates 24 hours for airport transfers, weddings, outstation tours, pilgrimage trips, corporate outings, and holiday travel."
      },
      {
        WhyChooseheading: "Comfortable AC Tempo Traveller for Group Travel",
        WhyChoosedescription: "All 17 seater Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, pilgrimage journeys, sightseeing travel, and multi-day outstation packages according to customer requirements."
      },
      {
        WhyChooseheading: "Perfect for Family & Corporate Groups",
        WhyChoosedescription: "Our 17 seater Tempo Traveller is ideal for family vacations, office outings, wedding guest transport, school trips, picnic tours, and tourist group travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Pune Airport, railway stations, and all major Pune locations."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Outstation Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is 17 seater Tempo Traveller on rent in Pune?", answer: "17 seater Tempo Traveller rental service in Pune provides comfortable group transportation for family tours, corporate travel, weddings, and outstation journeys." },
    { question: "Is 17 seater Tempo Traveller booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 17 seater Tempo Traveller rental service in Pune." },
    { question: "Is the 17 seater Tempo Traveller air-conditioned?", answer: "Yes, all 17 seater Tempo Travellers are air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book 17 seater Tempo Traveller for outstation trips?", answer: "Yes, customers can book 17 seater Tempo Travellers for hill stations, pilgrimage tours, holiday trips, and outstation travel from Pune." },
    { question: "Do you provide Tempo Traveller for corporate events in Pune?", answer: "Yes, Aaradhya Travels provides 17 seater Tempo Traveller service for office outings, conferences, employee transport, and corporate travel." },
    { question: "Can I book Tempo Traveller for weddings and family functions?", answer: "Yes, our 17 seater Tempo Travellers are ideal for wedding guest transportation and family group travel." },
    { question: "Can I book 17 seater Tempo Traveller online in Pune?", answer: "Yes, customers can easily book 17 seater Tempo Traveller service online or through phone booking." },
    { question: "Do you provide Pune Airport pickup and drop service?", answer: "Yes, Aaradhya Travels provides airport pickup and drop service using 17 seater Tempo Travellers." },
    { question: "Are Tempo Traveller rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Tempo Traveller rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Chavan",
    feedback:
      "Our pilgrimage trip became much more convenient with a 17 Seater Tempo Traveller on rent in Pune. The seating arrangement was comfortable, and the vehicle was maintained in excellent condition.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Madhuri Kale",
    feedback:
      "A 17 Seater Tempo Traveller rental in Pune helped our group travel together without any hassle. The journey was smooth, the interiors were clean, and everyone appreciated the spacious cabin.",
    rating: 5
  }
];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Tempo Traveller on Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/17-seater-tempo-traveller-pune.jpg",
  "description": "Book 17 Seater Tempo Traveller on rent in Pune with Aaradhya Travels for corporate travel, weddings, airport transfers, family trips, group travel, and outstation journeys including Shirdi, Mahabaleshwar, and Lonavala. Available AC and luxury seating with professional driver service.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/17-seater-tempo-traveller-on-rent-pune"
  }
};






  return (
    <div>

<Helmet>
  <title>
    17 Seater Tempo Traveller on Rent in Pune | Group & Outstation Travel | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 17 Seater Tempo Traveller on rent in Pune with Aaradhya Travels. Perfect for corporate trips, weddings, airport pickup, family travel, and outstation tours to Shirdi, Mahabaleshwar, and Lonavala with comfortable AC seating."
  />

  <meta
    name="keywords"
    content="17 seater tempo traveller Pune, 17 seater AC traveller Pune, 17 seater luxury traveller Pune, Pune to Shirdi 17 seater traveller, Pune to Mahabaleshwar 17 seater traveller, 17 seater outstation Pune, 17 seater wedding traveller Pune, 17 seater corporate traveller Pune, 17 seater airport pickup Pune, 17 seater family trip Pune, 17 seater group travel Pune, 17 seater Hinjewadi traveller, 17 seater Kharadi traveller, 17 seater Baner traveller, 17 seater Wakad traveller, 17 seater Pimpri Chinchwad traveller, 17 seater Pune darshan traveller, 17 seater Lonavala traveller, 17 seater Shirdi darshan"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/73.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Oneseventempotravelleronrent ;